import { LOG_IN_STATUS, LOGGED_IN } from "../utils";

export class UserLoginInformation {
  static getLogInMethod(): string {
    return localStorage.getItem("signInMethod");
  }
  static setLogInMethod(signInMethod: string) {
    localStorage.setItem("signInMethod", signInMethod);
  }

  static getLogInStatus(): string {
    return localStorage.getItem("signInStatus");
  }

  static setLogInStatus(signInStatus: string) {
    localStorage.setItem("signInStatus", signInStatus);
  }

  static getLoggedIn(): string {
    return localStorage.getItem("loggedIn");
  }

  static setLoggedIn(loggedIn: string) {
    localStorage.setItem("loggedIn", loggedIn);
  }

  static getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  static setUser(user: string) {
    if (user) {
      this.setLogInStatus(LOG_IN_STATUS.SUCCESS);
      this.setLoggedIn(LOGGED_IN.YES);
    }
    localStorage.setItem("user", JSON.stringify(user));
  }

  static clear() {
    this.setLogInMethod("");
    this.setLogInStatus("");
    this.setLoggedIn("");
    this.setUser("");
  }
}
